import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let WeaponFocuses = class WeaponFocuses extends VuexModule {
    constructor() {
        super(...arguments);
        this.weaponFocuses = [];
        this.cachedVersion = 0;
    }
    async fetchWeaponFocuses() {
        const { data: weaponFocuses, cachedVersion } = await fetchFromCache(this, 'weaponFocuses', 'weaponFocus');
        return { weaponFocuses, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['weaponFocuses', 'cachedVersion'] })
], WeaponFocuses.prototype, "fetchWeaponFocuses", null);
WeaponFocuses = __decorate([
    Module({ namespaced: true, name: 'weaponFocuses' })
], WeaponFocuses);
export default WeaponFocuses;
